import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import {
  FeatureCheckboxSelected,
  FeatureCheckboxUnselected,
  InfoIcon,
  PriceIcon,
} from '../../../shared/svg/components';
import { changeIsDescriptionOpened } from '../../../model/configuratorSlice';
import { getPriceText } from '../../../utils/currencyFormatter';
import { TranslationUtility } from '../../../utilities/TranslationUtility';
import IsNullOrUndefined from '../../../utils/ObjectUtils';
import { PriceUtility } from '../../../utilities/PriceUtility';

const FeatureItem = ({
  feature,
  categoryId,
  isSelected,
  onFeatureSelected,
  disabled,
}) => {
  const { settings, isPublic, vat } = useSelector(state => state.configurator);
  const dispatch = useDispatch();

  if (disabled) return null;

  return (
    <div className="feature-item">
      <div className="feature-title-container">
        <div className="feature-title">
          {TranslationUtility.GetFormattedMessageForUI('ui-feature-option', 'Opción')}{` ${feature.order}`}
        </div>
        {feature.description !== null && feature.description.length > 0 && (
        <button
          className="info-button"
          type="button"
          onClick={() => dispatch(changeIsDescriptionOpened({ isOpen: true, featureId: feature.id, categoryId }))}
        >
          <InfoIcon className="icon" />
        </button>
        )}
        <div className="price">{!isPublic ? PriceUtility.getFeatureFormattedPrice(feature, vat)
            : PriceUtility.getPublicFeatureFormattedPrice(feature, vat)}
        </div>
      </div>
      <button type="button" onClick={() => onFeatureSelected((feature.id))} className="feature-thumb">
        <div className="image-mask">
          <div className="image-container">
            <img src={`${settings.thumbs_base_url}/${feature.thumb}`} alt="" />
          </div>
          {isSelected
            ? <FeatureCheckboxSelected className="check" />
            : <FeatureCheckboxUnselected className="check" />}
        </div>
      </button>
      <div className="feature-name">{TranslationUtility.GetFormattedMessageForFeatureName(feature)}</div>
    </div>
  );
};

FeatureItem.propTypes = {
  feature: (PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    thumb: PropTypes.string,
    order: PropTypes.number,
    price: PropTypes.string,
  })).isRequired,
  categoryId: PropTypes.string.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onFeatureSelected: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default FeatureItem;
